import React from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import useStyles from "../../../assets/styles/HomeStyles";
import Icon1 from "../../../assets/images/DQProImages/Graphic3.png"
import Icon2 from "../../../assets/images/DQProImages/Graphic4.png"

const DQProOnboardingWhatYouCanDo = () => {
    const classes = useStyles();

    const cards = [
        {
            title: "Sell",
            image: Icon1,
            description: "Sell existing standardized, proven products such as assessments and learning programs to your clients.",
            button: {
                text: "View Products",
                link: "/dq_pro/products"
            },
            comingSoon: false
        },
        {
            title: "Build",
            image: Icon2,
            description: "Build your own high-quality digital literacy program for any target audience or build your own curated assessments.",
            button: {
                text: "Coming soon in Q3 2025",
                link: null
            },
            comingSoon: true
        }
    ];

    return (
        <Box className={classes.pageContainer}  style={{marginTop:'auto'}}>
            <Typography variant="h3" className={classes.title} sx={{ mb: 6, textAlign: 'center' }}>
                What You Can Do
            </Typography>

            <Grid container spacing={6} justifyContent="center">
                {cards.map((card, index) => (
                    <Grid item xs={12} md={5} key={index} sx={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Box sx={{
                            p: 4,
                            maxWidth: 400,
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}>
                            <Typography variant="h4" sx={{
                                fontWeight: 'bold',
                                mb: 3,
                                fontSize: '60px',
                                color: '#ff6468',
                            }}>
                                {card.title}
                            </Typography>

                            <img style={{height:'170px', marginTop:'0px'}} src={card.image} className={classes.cardImage} alt="Card Image" />
                            {/* Description */}
                            <Typography variant="body1" sx={{fontSize:'23px', mb: 4, mt:4 }}>
                                {card.description}
                            </Typography>

                            {card.comingSoon ? (
                                <Typography variant="body1" sx={{
                                    color: '#0097b2',
                                    fontSize:'25px',
                                    fontWeight:'bold',
                                }}>
                                    {card.button.text}
                                </Typography>
                            ) : (
                                <Button
                                    variant="contained"
                                    href={card.button.link}
                                    sx={{
                                        backgroundColor: '#0097b2',
                                        width: '100%',
                                        fontWeight: 'bold',
                                        fontSize: '16px',
                                        borderRadius: '20px',
                                        '&:hover': {
                                            backgroundColor: '#0097b2',
                                            color:'#ffffff'
                                        }
                                    }}
                                >
                                    {card.button.text}
                                </Button>
                            )}
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default DQProOnboardingWhatYouCanDo;